export default __webpack_public_path__ + "static/media/experiences_item_gray.857773ae.svg";